import { css } from 'linaria';

export namespace Styles {
  export const inputContainer = css`
    display: none;
  `;
}
